<template>
    <div class="social">
        <h4>{{$t('contact_us')}}</h4>
        <a class="social-item skype" href="skype:pabklitecom@gmail.com?chat" @click.passive="sendLink"><i class="icon-skype" /><span>pabklitecom@gmail.com</span></a>
        <a class="social-item whatsapp" href="https://wa.me/35799837642" @click.passive="sendLink" target="_blank"><i class="icon-whatsapp" /><span>+357 99 837642</span></a>
        <a class="social-item email" href="mailto:sales@mbk777.com" @click.passive="sendLink" target="_top"><i class="icon-email" /><span>sales@mbk777.com</span></a>
    </div>
</template>

<script>
import ga from '../plugins/ganalitycs'

export default {
  name: 'Social',
  methods:{
      sendLink(event){
          ga.sendLink(event.target.href);          
      }
  }
}
</script>

<style lang="scss" >
    .social {
        h4 {
            font-size: 1.4rem;
            font-weight: normal;
            text-transform: uppercase;
            margin: 0;
        }
    }
</style>
